import { Button, Modal } from "react-bootstrap";
import axios from "axios";
import { toast } from "react-toastify";
import { getApiUrl } from "@utils/baseUrl";
import { captureException } from "@sentry/react";
import { useDispatch } from "react-redux";
import { getFavouriteDetailsHandler } from "@redux/Bookmark/bookmark.action";
import { getSidebarCountData } from "../../../../redux/Sidebar/sidebarCount.action";
import { profileName, profileType } from "@utils/enum";
import { capitalizeLetter } from "@utils/hooks";

const intelAPIEndpoints = {
  deleteFavouriteCompany: getApiUrl("deleteFavouriteCompany"),
};

export const FavouriteSingleDeleteModal = ({ selectedCompany, showSingleData, setShowSingleData, payload, setPayload, setSingleData, setCurrentPage, type }) => {
  const dispatch = useDispatch();

  const submitHandler = () => {
    axios
      .post(intelAPIEndpoints.deleteFavouriteCompany, {
        company_ids: Array.isArray(selectedCompany) ? selectedCompany.map((company) => company.id) : [selectedCompany.id],
      })
      .then(() => {
        setSingleData({});
        setCurrentPage(1);
        if (!Array.isArray(selectedCompany) && selectedCompany?.company_name) {
          toast.success(`${capitalizeLetter(selectedCompany.company_name)}  has been removed successfully`);
        }
        setShowSingleData(false);
        dispatch(getFavouriteDetailsHandler({ payload }));
        setPayload(payload);
        dispatch(getSidebarCountData());
      })
      .catch((error) => {
        captureException(error);
      });
  };

  return (
    <div>
      <Modal size="md" centered show={showSingleData} onHide={() => setShowSingleData(false)}>
        <Modal.Header className="p-2" closeButton>
          <div className="d-flex justify-content-between w-100 align-items-center">
            <div className="ml-2">
              <strong>Confirmation</strong>
            </div>
          </div>
        </Modal.Header>
        <Modal.Body>
          <p className="m-0 ">
            You are removing{" "}
            <span>
              <b>{type === profileType.shipments ? (Array.isArray(selectedCompany) ? `${selectedCompany.length} ${selectedCompany.length === 1 ? "shipment" : "shipments"}` : "1 shipment") : selectedCompany.company_name}</b>
            </span>
          </p>
          <p className="m-0">Please confirm if you want to remove {profileName[type]} from your bookmarks.</p>
        </Modal.Body>
        <Modal.Footer>
          <div>
            <Button
              className="btn btn-danger delete-btn-upsell"
              onClick={() => {
                submitHandler();
              }}>
              Remove
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    </div>
  );
};
